import React from "react";
import classNames from 'classnames'

import Checkbox from './Checkbox'
export default function MultiSelectDropdownOption(props) {
    const { label, value, disabled, maxReached, selected } = props;

    let className = classNames('multi-select-dropdown-option', { 'selected': selected }, { 'disabled': disabled });

    // Controlled by the parent's selectedOptions state (props.selected) only - no local
    // copy of the selection - so this row always reflects the current selection even when
    // the list is re-keyed/reordered (e.g. sortSelectedFirst).
    function handleOptionClick() {
        if (!maxReached || selected) {
            props.handleOptionClick(value)
        } else {
            alert("You have reached maximum limit of options to select!")
        }
    }

    return (
        <li>
            <button type="button" className={className} onClick={disabled ? null : handleOptionClick}>
                <Checkbox checked={selected} />
                <span className='multi-select-dropdown-option-label'>{label}</span>
            </button>
        </li>
    )
}